{
  "id": "campaign-095",
  "name": "Quiet Walk",
  "seed": "campaign:95",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    ".h...__...h.",
    "....T__T....",
    ".i.i.__.i.i.",
    ".....__.....",
    "....x__.....",
    ".i.i.__.i.i.",
    ".....__,,...",
    ".x...__,..X.",
    "____________",
    "%%~x.__.,..,",
    "%~~~.__,,%%,",
    "..,X.__.,%.,",
    ".,,,.__.....",
    ".h,h.__.h.h.",
    "....X__X....",
    ".X...X......",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 9,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 10
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 95,
  "biome": "cemetery",
  "par": {
    "reel": 7680,
    "push": 6267,
    "selfPropelled": 5802,
    "tractor": 4785,
    "zeroTurn": 3781,
    "fairway": 3124
  },
  "routeTries": {
    "par": {
      "reel": 14,
      "push": 2,
      "selfPropelled": 4,
      "tractor": 8,
      "zeroTurn": 3,
      "fairway": 13
    }
  }
}
